// extracted by mini-css-extract-plugin
export default {"ZccAdd":"ZccAddDark__ZccAdd___Nw-Vy"};